import { Box, Stack, Typography } from '@mui/material';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { useGetResponsive } from '@stack/helpers/lib/responsive';

export type SliderComponentProps = {
  onSliderChange?: (event: Event, value: number | number[]) => void;
  sliderValue?: string;
  selectedSliderValues?: number;
  marks: {
    value: number;
    label: string;
  }[];
  title: string;
};

export const SliderComponent: React.FC<SliderComponentProps> = (props) => {
  interface AirbnbThumbComponentProps extends React.HTMLAttributes<unknown> {}

  const AirbnbThumbComponent = (props: AirbnbThumbComponentProps) => {
    const { children, ...other } = props;
    return (
      <SliderThumb {...other}>
        {children}
        <svg
          width="12"
          height="15"
          viewBox="0 0 12 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 5.46838C0 5.1716 0.131823 4.89015 0.359816 4.70015L5.35982 0.533487C5.73066 0.224448 6.26934 0.224449 6.64018 0.533487L11.6402 4.70015C11.8682 4.89015 12 5.1716 12 5.46837V14C12 14.5523 11.5523 15 11 15H1C0.447715 15 0 14.5523 0 14V5.46838Z"
            fill="#31ACBF"
          />
        </svg>
      </SliderThumb>
    );
  };

  const { sliderValue, selectedSliderValues, onSliderChange, marks, title } =
    props;

  const valueLabelFormat = (value: number) => `${value}`;

  const { lg } = useGetResponsive();

  return (
    <Box sx={{ width: '100%' }}>
      <Stack
        flexDirection="row"
        sx={{ justifyContent: 'space-between', paddingBottom: 4 }}
      >
        <Typography fontWeight={500} fontSize={'0.875rem'} color="#1E242F">
          {title}
        </Typography>
        <Typography fontWeight={500} fontSize={'0.875rem'} color="#67708C">
          {sliderValue}
        </Typography>
      </Stack>
      <Box sx={{ width: '100%', padding: '24px 10px 0' }}>
        <Slider
          sx={{
            color: '#3a8589',
            height: 3,
            marginBottom: 0,
            padding: '13px 0 33px',
            '& .MuiSlider-thumb': {
              height: 27,
              width: 27,
              paddingTop: 8,
              backgroundColor: 'transparent',
              boxShadow: 'none !important',
              '&:before': {
                boxShadow: 'none',
              },
              '&:hover': {
                boxShadow: 'none',
              },
              pointerEvents: lg ? 'none' : 'auto',
            },
            '& .MuiSlider-mark': {
              backgroundColor: '#A8B5C9',
              height: 8,
              marginTop: -2,
              fontSize: '1.25rem',
            },
            '& .MuiSlider-markLabel': {
              top: '-18px !important',
              color: '#A8B5C9',
            },
            '& .MuiSlider-valueLabel': {
              backgroundColor: 'transparent',
              color: '#31ACBF',
              marginTop: -3,
              fontSize: '1.25rem',
            },
            '& .MuiSlider-track': {
              height: 8,
              borderRadius: 4,
              backgroundColor: '#31ACBF',
              border: 'none',
            },
            '& .MuiSlider-rail': {
              height: 8,
              borderRadius: 4,
              backgroundColor: '#EDECED',
            },
          }}
          marks={marks}
          getAriaValueText={valueLabelFormat}
          value={selectedSliderValues}
          components={{ Thumb: AirbnbThumbComponent }}
          onChange={onSliderChange}
          valueLabelDisplay="auto"
          min={marks[0].value}
          max={marks[marks.length - 1].value}
        />
      </Box>
    </Box>
  );
};

export default SliderComponent;
